export enum GRID_FILTER_KEYS {
	FILLED_QUESTIONNAIRES_FILTER = 'GRID_FILTER_FILLED_QUESTIONNAIRES_FILTER',
	CLOSED_CASES_FILTER = 'GRID_FILTER_CLOSED_CASES_FILTER',
	ASSIGNED_CASES_FILTER = 'GRID_FILTER_ASSIGNED_CASES_FILTER',
	NURSE_CASES_FILTER = 'GRID_FILTER_NURSE_CASES_FILTER',
	WORKPLACE_CASES_FILTER = 'GRID_FILTER_WORKPLACE_CASES_FILTER',
	SURVEILLANCE_CENTER_FILTER = 'GRID_FILTER_SURVEILLANCE_CENTER_FILTER',
	EARCHIVE_FILTER = 'GRID_FILTER_EARCHIVE_FILTER',
	INVOICING_FILTER = 'GRID_FILTER_INVOICING_FILTER',
	MONITORING_CENTER_ALL_REQUESTS_FILTER = 'GRID_FILTER_MONITORING_CENTER_ALL_REQUESTS_FILTER',
	MONITORING_CENTER_NEW_REQUESTS_FILTER = 'GRID_FILTER_MONITORING_CENTER_NEW_REQUESTS_FILTER',
	MONITROING_CENTER_SOLVED_REQUESTS_FILTER = 'GRID_FILTER_MONITROING_CENTER_SOLVED_REQUESTS_FILTER',
	PATIENTS_FILLED_QUESTIONNAIRES_FILTER = 'GRID_FILTER_PATIENTS_FILLED_QUESTIONNAIRES_FILTER',
	PLANNED_QUESTIONNAIRES_FILTER = 'PLANNED_QUESTIONNAIRES_FILTER',
	MANAGER_WORKPLACE_WORKERS = 'MANAGER_WORKPLACE_WORKERS',
	PATIENTS_GROUPS_FILTER = 'PATIENTS_GROUPS_FILTER',
	LABORATORY_RESULTS = 'LABORATORY_RESULTS',
	MANAGER_INSURANCE_REPORT_FILTER = 'MANAGER_INSURANCE_REPORT_FILTER',
	ALL_WORKPLACES_CALENDAR = 'ALL_WORKPLACES_CALENDAR',
	WORKPLACE_DOCTOR_STATISTICS_FILTER = 'WORKPLACE_DOCTOR_STATISTICS_FILTER',
}
